<template>
	<div class="wrapper">
		<nav
			class="main-header navbar navbar-expand navbar-white navbar-light bg-white text-dark font-weight-bold elevation-1"
		>
			<ul class="navbar-nav align-middle">
				<li class="nav-item nav-focus nav-brand">
					<a
						class="nav-link text-dark"
						data-widget="pushmenu"
						href="#"
						role="button"
						style="font-family: NunitoBlack"
						><i class="fas fa-bars d-md-none"></i>&nbsp;&nbsp;
						<span class="full-text">Speke Management System</span>
						<span class="short-text">SMS</span></a
					>
				</li>
				<li class="nav-item nav-focus d-none">
					Budget Information System (BIS):
				</li>
			</ul>

			<ul class="navbar-nav ml-auto">
				<li class="nav-item d-none">
					<a
						class="nav-link"
						data-widget="navbar-search"
						href="#"
						role="button"
					>
						<i class="fas fa-search"></i>
					</a>
					<div class="navbar-search-block">
						<form class="form-inline">
							<div class="input-group input-group-sm">
								<input
									class="form-control form-control-navbar"
									type="search"
									placeholder="Search"
									aria-label="Search"
								/>
								<div class="input-group-append">
									<button class="btn btn-navbar" type="submit">
										<i class="fas fa-search"></i>
									</button>
									<button
										class="btn btn-navbar"
										type="button"
										data-widget="navbar-search"
									>
										<i class="fas fa-times"></i>
									</button>
								</div>
							</div>
						</form>
					</div>
				</li>

				<li class="nav-item dropdown d-inline-block">
					<a
						class="nav-link dropdown-toggle"
						data-toggle="dropdown"
						href="#"
						role="button"
					>
						<img
							src="/adminlte/dist/img/placeholder.jpg"
							class="img-circle elevation-2"
							alt="User Image"
							style="width: 30px; height: 30px; object-fit: cover"
						/>
						<span v-if="user" class="ms-2 d-xl-inline-block">
							{{ user.name }}
						</span>
					</a>
					<div
						class="dropdown-menu dropdown-menu-lg dropdown-menu-right rounded-0 mt-3 w-100"
					>
						<a class="dropdown-item d-none" href="/profile">
							<i class="far fa-user me-2"></i>
							<span>Personal Profile</span>
						</a>
						<a class="dropdown-item d-none" href="/paxroster">
							<i class="far fa-clock me-2"></i>
							<span>Personal Leave</span>
						</a>
						<div class="dropdown-divider d-none"></div>
						<a
							class="dropdown-item text-danger"
							href="#"
							@click.prevent="logout()"
						>
							<i class="fas fa-power-off me-2"></i>
							<span>Logout</span>
						</a>
					</div>
				</li>

				<li class="nav-item d-none">
					<a class="nav-link" data-widget="fullscreen" href="#" role="button">
						<i class="fas fa-expand-arrows-alt"></i>
					</a>
				</li>
				<li class="nav-item d-none">
					<a
						class="nav-link"
						data-widget="control-sidebar"
						data-slide="true"
						href="#"
						role="button"
					>
						<i class="fas fa-th-large"></i>
					</a>
				</li>
			</ul>
		</nav>
		<sidebar />
		<div class="content-wrapper p-1">
			<router-view />
		</div>

		<footer class="main-footer d-none">
			<div class="float-right d-none d-sm-block"><b>Version</b> 3.2.0</div>
			<strong>Copyright &copy; 2024 </strong>
			All rights reserved.
		</footer>

		<aside class="control-sidebar control-sidebar-dark"></aside>
	</div>
</template>

<script>
import axios from "axios";
axios.defaults.withCredentials = true;
import config from "../config/settings.js";

import Navbar from "./inc/Navbar.vue";
import Sidebar from "./inc/Sidebar.vue";

export default {
	components: {
		Navbar,
		Sidebar,
	},
	data() {
		return {
			api: config.API_URL,
			prefix: config.API_PFX,
			user: null,
		};
	},
	methods: {
		getAuth(key) {
			const itemStr = sessionStorage.getItem(key);

			// if the item doesn't exist, return null
			if (!itemStr) {
				return null;
			} else {
				const item = JSON.parse(itemStr);
				const now = new Date();

				// compare the expiry time of the item with the current time
				if (now.getTime() > item.expiry) {
					// If the item is expired, delete the item from storage
					// and return null
					sessionStorage.removeItem(key);
					return null;
				} else {
					return item.value;
				}
			}
		},
		async authUser() {
			var user_id, auth, query, api;
			user_id = sessionStorage.getItem("user_id");
			auth = this.getAuth("auth");

			if (auth == null) {
				this.$router.push({ path: "/" });
				this.showError("Session time out", 599);
			} else {
				if (user_id == null) {
					this.$router.push({ path: "/" });
					this.showError("Session time out", 599);
				} else {
					api = this.api + this.prefix + "/user/" + user_id;
					query = await this.getData(api);
					if (query.result == "success") {
						this.user = query.response.data;
						// console.log(this.user.names);
					} else {
						// this.message = query.error.message;
						this.http_code = query.code;
					}
				}
			}
		},
		logout() {
			axios.post(this.api + this.prefix + "/logout").then(() => {
				sessionStorage.clear();
				this.message = "You've Logged Out";

				this.showMessage(this.message);
				this.$router.push({ path: "/" });
			});
		},
	},
	watch: {},
	computed: {},
	created() {},
	mounted() {
		this.authUser();
	},
	unmounted() {},
};
</script>

<style scoped>
@import "../../public/asset/css/general.css";
</style>

